import React from 'react';
import { Box } from '@mui/material';

const vendorActions = [
  { icon: '📄', color: 'amber', title: 'ISO 9001 expiring', desc: 'Certification expires in 18 days (05 Sep 2026)' },
  { icon: '📋', color: 'blue', title: 'Trade license missing', desc: 'Upload valid copy to remain compliant' },
  { icon: '💰', color: 'red', title: '₹1.45L overdue', desc: 'INV-3021 payment due since 02 Aug (16 days)' },
  { icon: '📦', color: 'teal', title: '2 POs due this week', desc: 'PO1023, PO1032 delivery expected' },
];

export default function VendorActionCenterCard() {
  return (
    <Box className="card" id="vendActionCard" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Action Center</h3>
      </div>
      <div className="alert-list" style={{ height: '220px', overflow: 'auto' }}>
        {vendorActions.map((action, i) => (
          <Box key={i} className="alert-item">
            <Box
              className={`alert-icon ${action.color === 'red' ? 'crit' : action.color === 'blue' ? 'info' : 'warn'}`}
              style={{ background: `var(--${action.color}-bg)`, color: `var(--${action.color})` }}
            >
              {action.icon}
            </Box>
            <Box className="alert-text">
              <b>{action.title}</b>
              <div className="alert-time">{action.desc}</div>
            </Box>
          </Box>
        ))}
      </div>
    </Box>
  );
}
